module.exports = __webpack_public_path__ + "img/regular_pending_verification.d0c1b195.svg";